import React, { Component } from "react";
// import mySite1 from '../assets/image/img-my-site-1.png';
// import mySite2 from '../assets/image/img-my-site-2.png';
// import mySite3 from '../assets/image/img-my-site-3.png';
import loader from "../assets/image/half-circle.gif";
import PdfIcon from "../assets/image/img-pdf-icon.png";
import ReactModal from "react-modal";
import { withTranslation } from "react-i18next";
class MySites extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      imageUrl: "",
    };
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleOpenModal(e, imageUrl) {
    this.setState({ showModal: true, imageUrl });
  }

  handleCloseModal() {
    this.setState({ showModal: false, imageUrl: "" });
  }

  render() {
    let { siteDetails, loading, dataNotFound, t, isWrap, handleViewAllSite } =
      this.props;
    const { showModal, imageUrl } = this.state;
    let list = [...siteDetails];
    if (!isWrap) {
      if (siteDetails && siteDetails.length) list = list.slice(0, 3);
    } else {
      list = siteDetails;
    }

    return (
      <div className="card" id="mySites">
        <div className="card-header">
          <h3 className="card-header-title">{t("My Sites")}</h3>
          {siteDetails && siteDetails.length && siteDetails.length > 3 ? (
            <div>
              {siteDetails.length > 3 ? !isWrap ? (
                <span
                  className="card-header-action"
                  onClick={() => {
                    // this.props.history.replace({
                    //   pathname: `sites/1251146b-48d3-4141-aefc-dd494a16bbc8`,
                    // });
                    handleViewAllSite(true);
                  }}
                >
                  View All
                </span>
              ) : (
                <span
                  className="card-header-action"
                  onClick={() => {
                    // this.props.history.replace({
                    //   pathname: `sites/1251146b-48d3-4141-aefc-dd494a16bbc8`,
                    // });
                    handleViewAllSite(false);
                  }}
                >
                  View less
                </span>
              ):null}
            </div>
          ) : null}
        </div>
        <div
          className="card-body card-body-image-list"
          style={{ height: isWrap ? 490 : "auto", overflow: "auto" }}
        >
          {loading ? (
            <div className="card-loader">
              <img src={loader} alt="loading..." />
            </div>
          ) : dataNotFound ? (
            <div className="card-loader">{t("Data not found")}</div>
          ) : siteDetails && siteDetails.length > 0 ? (
            <div style={{ flexWrap: isWrap ? "wrap" : "nowrap" }}>
              {list &&
                list.map((eachItem, i) => {
                  return (
                    <>
                     {
                        eachItem.site_images.length > 0?
                        <div className="card-item-content">
                                  <h5 className="card-item-title">
                                    {eachItem.caption}
                                  </h5>
                                  {/* <p className="card-item-info">
                                    {eachItem.year}
                                  </p> */}
                                </div>
                        :null
                      }
                    <div className="card-list" key={`sites_images-${i}`}>
                     
                       
                      {eachItem.site_images.length > 0
                        ? eachItem.site_images.map((eachImage, i) => {
                            return (
                              <div key={i} className="card-item">
                                <div className="card-item-image">
                                  {eachImage.url &&
                                  eachImage.url.split(".").pop() === "pdf" ? (
                                    <img
                                      src={PdfIcon}
                                      alt="siteDetails"
                                      onClick={() => {
                                        window.open(eachImage.url, "_blank");
                                      }}
                                    />
                                  ) : eachImage.url ? (
                                    <img
                                      src={eachImage.url}
                                      alt="siteDetails"
                                      onClick={(e) =>
                                        this.handleOpenModal(e, eachImage.url)
                                      }
                                    />
                                  ) : null}
                                </div>
                               
                              </div>
                            );
                          })
                        : null}
                    </div>
                    </>
                  );
                })}
            </div>
          ) : (
            <div className="card-loader">{t("Data not found")}</div>
          )}
        </div>
        <ReactModal
          isOpen={showModal}
          contentLabel="Minimal Modal Example"
          className="Modal modal-preview"
          overlayClassName="Overlay"
          onRequestClose={this.handleCloseModal}
        >
          <img src={imageUrl} alt="Sites" className="card-item-image-preview" />

          <button onClick={this.handleCloseModal} className="modal-close">
            {" "}
            <i className="fa fa-close"></i>{" "}
          </button>
        </ReactModal>
      </div>
    );
  }
}

export default withTranslation()(MySites);
